import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { QuizService } from 'src/app/services/quiz.service';
import { UserRoleService } from 'src/app/services/user-role.service';
import { JobService } from 'src/app/services//jobs/job.service';
import { MatSnackBar, MatDialog } from '@angular/material';
import { Observable } from 'rxjs';
import { SignaturePadComponent } from 'src/app/commons/signature-pad/signature-pad.component';
import { TimeSheetService } from '../../services/time-sheet.service';
import { takeUntil } from 'rxjs/operators';
import * as _ from 'lodash';
@Component({
  selector: 'app-assessment',
  templateUrl: './assessment.component.html',
  styleUrls: ['./assessment.component.scss']
})
export class AssessmentComponent implements OnInit {

  status = ['Completed', 'Requested for Resubmission']

  assessmentForm;
  loading: boolean;
  quizId: any;
  learnerId: any;
  jobId: any;
  user;

  @Input('assessment') assessment;
  marks: any;
  remarks: any;
  // @Input('learnerStatus') learnerStatus;
  trainerSign
  trainerSignError
  iqaSign;
  iqaSignError;
  garbageSignatures = []
  showSignatureTrainer: boolean
  hideSubmitBtn: boolean;
  buttonLoaderSubmit: boolean = false;
  assesmentList = []
  displayStatus
  currentUser: any;
  isAdmin: boolean = false;
  isLearner: boolean = false;
  isIQA: boolean = false;
  isTrainer: boolean = false;
  userRole: any;
  constructor(
    public formBuilder: FormBuilder,
    public activatedRoute: ActivatedRoute,
    public _quizService: QuizService,
    public router: Router,
    public _snackBar: MatSnackBar,
    public dialog: MatDialog,
    public _timeSheetService: TimeSheetService,
    public _jobService: JobService,
    public _userRoleService: UserRoleService
  ) {
    // this._jobService.getSingleJob().subscribe((job) => {
    //   console.log("single job in assessment component------>  ", job);
    // })
    console.log("assesment value ========>", this.assessment)

  }

  ngOnInit() {

    // this.user = JSON.parse(localStorage.getItem('userRoles'))
    // this.showSignatureTrainer = this.user.isTrainer ? true : false;
    this.activatedRoute.url.subscribe(url => {
      console.log("%cquery params here", "color:red", "URL", url)
    })
    console.log("%cquery params here", "color:red", "URL", this.router.url)
    let temp = this.router.url.split('=')

    this.learnerId = temp[2].split('&')[0]
    this.quizId = temp[1].split('&')[0]
    this.jobId = temp[3].split('&')[0]
    console.log("what is temp value", temp[3].split('&'));
    // this.getJobId()
    // this.quizId = temp2[0]
    // this.activatedRoute.query.subscribe(qparam => {
    //   console.log("%cquery params here", "color:red", qparam)
    //   this.quizId = qparam.quizId
    //   this.learnerId = qparam.learnerId
    // })
    console.log("%cquery params here", "color:red", "temp", temp, this.learnerId, this.quizId)

    this.createForm()
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.loading = false;
    console.log("ON CHANGES of status========", changes);
    if (changes.assessment && changes.assessment.currentValue) {
      let displayData = changes.assessment.currentValue
      this.trainerSign = displayData.trainerSign
      this.iqaSign = displayData.iqaSign
      this.assesmentList = displayData.assesmentList
      this.displayStatus = displayData.lastStatus
      this.userRole = displayData.role
      this.getUserRole()
    }
  }

  createForm() {
    if (this.isIQA) {
      this.assessmentForm = new FormGroup({
        marks: new FormControl(''),
        remarks: new FormControl(''),
        status: new FormControl('')
      })
    } else {
      this.assessmentForm = new FormGroup({
        marks: new FormControl(''),
        remarks: new FormControl(''),
        status: new FormControl('', Validators.required)
      })
    }
    if (this.isIQA)
      this.assessmentForm.disable()

  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }
  getJobId() {
    console.log("this is the single job id to get job data", this.jobId);

    this._jobService.getJobById(this.jobId).subscribe((job) => {
      console.log("job.......", job);

      this.createForm()
      let getRole = this._userRoleService.getUserRole(job.data[0].instructors, 'job');
      if (getRole.isAdmin) this.isAdmin = true
      else if (getRole.isLearner) this.isLearner = true
      else if (getRole.isTrainer) this.isTrainer = true
      else if (getRole.isIQA) this.isIQA = true

      this.showSignatureTrainer = this.isTrainer ? true : false;
    })
  }


  getUserRole() {
    console.log("what is the user role value", this.userRole);
    if (this.userRole == 0) this.isAdmin = true
    else if (this.userRole == 1) this.isTrainer = true
    else if (this.userRole == 2) this.isIQA = true
    else if (this.userRole == 3) this.isLearner = true
  }

  redirect(role) {
    console.log("ROLE +++++++++++++++>", role)
    if ((role == 'trainer' && this.isAdmin && this.trainerSign)) {
    } else if ((role == 'iqa' && this.isAdmin && this.iqaSign)) {
    } else if ((role == 'trainer' && this.isIQA) || (this.isTrainer && this.trainerSign)) {
    } else if ((role == 'iqa' && this.isTrainer) || (this.isIQA && this.iqaSign)) {
    } else {
      this.openDialog(SignaturePadComponent).subscribe(data => {
        if (data) {

          switch (role) {
            case "trainer":
              if (this.trainerSign) {
                this.garbageSignatures.push(this.trainerSign);
              }
              this.trainerSign = data;
              this.trainerSignError = false;
              // code...
              break;
            case "iqa":
              if (this.iqaSign) {
                this.garbageSignatures.push(this.iqaSign);
              }
              if (this.trainerSign) {
                this.garbageSignatures.push(this.trainerSign);
              }
              /*this.trainerSign = data;
              this.trainerSignError = false;*/
              this.iqaSign = data;
              this.iqaSignError = false;
              // code...
              break;
            default:
              // code...
              break;
          }

          console.log("this.trainerSign =====> ", this.trainerSign);
          console.log("data from signature", data)
        }

      })
    }
    // }
  }
  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, {
      data, maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%'
    });
    return dialogRef.afterClosed();
  }



  submit() {
    // this.loading = true
    console.log(" =>", this.trainerSign)


    this._timeSheetService.getSystemDate().subscribe((date) => {
      console.log("single date value", date);
      let systemDate = date.systemDate
      if (!this.trainerSign && (this.isTrainer || this.isAdmin)) {
        this.trainerSignError = true
      } else if (!this.iqaSign && (this.isIQA || this.isAdmin)) {
        this.iqaSignError = true
      } else if (this.isIQA && this.iqaSign) {
        let obj = {
          quizId: this.quizId,
          learnerId: this.learnerId,
          jobId: this.jobId,
          iqaSign: this.iqaSign,
          isIQA: true
        }
        this._quizService.updateAssessment(obj).subscribe(res => {
          console.log("RESPONSE IN COMP", res);
          this.openSnackBar("Signature added successfully", "OK")
          this.router.navigate(['/user/' + this.learnerId], { queryParams: { job: this.jobId } })
          // this.loading = false
        })
      } else {
        let obj = {
          quizId: this.quizId,
          learnerId: this.learnerId,
          assessment: this.assessmentForm.value,
          trainerSign: this.trainerSign,
          iqaSign: this.iqaSign,
          garbageSignatures: this.garbageSignatures,
          jobId: this.jobId
        }
        obj.assessment['createdDate'] = systemDate
        // console.log("assessmentForm", this.assessmentForm)
        console.log("Final object", obj)
        if (this.assessmentForm.valid) {
          this.buttonLoaderSubmit = true
          console.log("obj to send ", obj);
          this._quizService.updateAssessment(obj).subscribe(res => {
            console.log("RESPONSE IN COMP", res);
            this.openSnackBar("Marks saved successfully", "OK")
            this.router.navigate(['/learner/view/' + this.learnerId], { queryParams: { job: this.jobId } })
            // this.loading = false
          })
        }
        else {
          alert('Please Fill the form properly');
        }
      }
    })
  }

}
